import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const profile = state.user.profile;

  if (isEmpty(profile)) {
    return "Welcome, User";
  }

  if (profile.name) {
    return profile.name;
  } else {
    return "Welcome, User";
  }
};
//VERIFY IF THE JWT IS SET
const getDisplayName = createSelector(getData, name => name);
export default getDisplayName;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getDisplayName.js